module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (!item.isGroupChild) { 
__p+='\n    <div class="row row-nospace">\n        <div class="page-col-offset input-help">\n                <span class="create-step-number">&nbsp;</span>\n                <span class="input-helper">'+
((__t=( icon('info') ))==null?'':__t)+
'</span>\n        </div>\n        <div class="page-col-3">\n            <label for="field-'+
((__t=(item.field.name))==null?'':_.escape(__t))+
'" class="label-headline">'+
((__t=(item.field.label))==null?'':_.escape(__t))+
'</label>\n        </div>\n    </div>\n';
 } 
__p+='\n\n<div class="row">\n    <div class="page-col-3 page-offset-default">\n        <div class="input-label-group">\n            <input\n                type="text"\n                name="'+
((__t=(item.field.name))==null?'':_.escape(__t))+
'"\n                id="field-'+
((__t=(item.field.name))==null?'':_.escape(__t))+
'"\n                placeholder="'+
((__t=(item.field.placeholder))==null?'':_.escape(__t))+
'"\n                value="'+
((__t=(model.get(item.field.name)))==null?'':_.escape(__t))+
'"\n            />\n            ';
 if (item.isGroupChild) { 
__p+='\n                <label data-position="right" for="field-'+
((__t=(item.field.name))==null?'':_.escape(__t))+
'">'+
((__t=(item.field.label))==null?'':_.escape(__t))+
'</label>\n            ';
 } 
__p+='\n        </div>\n    </div>\n</div>';
}
return __p;
};